import { useState, useEffect } from 'react';
import CherryBlossoms from './CherryBlossoms';
import InkBrush from './InkBrush';

const SakuraAesthetics = () => {
  const [isDarkMode, setIsDarkMode] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    setIsDarkMode(document.documentElement.classList.contains('dark'));
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: -1,
      }}
      aria-hidden="true"
    >
      {/* Layer 1: Subtle ink brush strokes */}
      <InkBrush isDarkMode={isDarkMode} />

      {/* Layer 2: Falling cherry blossom petals */}
      <CherryBlossoms isDarkMode={isDarkMode} />
    </div>
  );
};

export default SakuraAesthetics;
